import React from "react";
import { t } from "../../i18n";

/**
 * MontageCreator – Form to create a new montage (title, format, resolution).
 *
 * Props:
 * - montage: object – Current montage state (for title, aspect_ratio, resolution)
 * - loading: boolean – Loading state
 * - onUpdate: function(field, value) – Update a montage field
 * - onCreate: function – Create the montage
 */
export default function MontageCreator({ montage, loading, onUpdate, onCreate }) {
    return (
        <section className="montage-card">
            <div className="montage-project-bar">
                <h3>{t("montage.create.title")}</h3>

                <div className="montage-form-group">
                    <label>{t("montage.label.montageTitle")}</label>
                    <input
                        type="text"
                        value={montage.title}
                        onChange={(e) => onUpdate("title", e.target.value)}
                        placeholder={t("montage.placeholder.title")}
                        className="montage-input"
                    />
                </div>

                <div className="montage-form-row">
                    <div className="montage-form-group">
                        <label>{t("montage.label.format")}</label>
                        <select
                            value={montage.aspect_ratio}
                            onChange={(e) => onUpdate("aspect_ratio", e.target.value)}
                            className="montage-select"
                        >
                            <option value="16:9">16:9 ({t("montage.format.landscape")})</option>
                            <option value="9:16">9:16 ({t("montage.format.portrait")})</option>
                            <option value="1:1">1:1 ({t("montage.format.square")})</option>
                            <option value="4:3">4:3</option>
                        </select>
                    </div>

                    <div className="montage-form-group">
                        <label>{t("montage.label.resolution")}</label>
                        <select
                            value={montage.resolution}
                            onChange={(e) => onUpdate("resolution", e.target.value)}
                            className="montage-select"
                        >
                            <option value="720p">720p</option>
                            <option value="1080p">1080p</option>
                            <option value="4k">4K</option>
                        </select>
                    </div>
                </div>

                <div className="montage-actions">
                    <button
                        onClick={onCreate}
                        disabled={!montage.title.trim() || loading}
                        className="montage-btn montage-btn-primary"
                    >
                        {loading ? t("montage.btn.creating") : t("montage.btn.createMontage")}
                    </button>
                </div>
            </div>
        </section>
    );
}
